import React, { useState } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useVerifyBookingByQrMutation } from "../../Redux/apis/ApiSlice";
import { notification } from "antd";
import jsQR from "jsqr";
import dayjs from "dayjs";

const AlphaNumericTicketInfo = () => {
  const location = useLocation();
  const [buyerName1, setBuyerName] = useState("");
  const [verifyBookingByQr] = useVerifyBookingByQrMutation();
  // Destructure booking data directly from location.state.booking
  const bookingData = location.state?.booking;
  console.log("bookingData", bookingData);
  if (!bookingData) {
    return <Typography>No booking data available.</Typography>;
  }

  const {
    bookingId,
    totalPrice,
    buyerDetails: { buyerName },
    eventDetails: {
      ticketTypes = [],
      eventId,
      eventName,
      location: eventLocation,
      date: eventDate,
      time: eventTime,
    },
  } = bookingData;
  const handleScanComplete = async () => {
    const userData = localStorage.getItem("userData");
    const parsedData = JSON.parse(userData);
    // Extract the id
    const userId = parsedData?.id;
    try {
      const response = await verifyBookingByQr({
        eventId: Number(bookingData.eventDetails.eventId),
        userId: Number(userId),
        bookingId: Number(bookingId),
        ticketCode: Number(bookingData?.code),
      }).unwrap();
      notification.success({ message: "Verification successful!" });
      // Show the result modal or popup only on success
    } catch (err) {
      console.error("Verification failed:", err);
      notification.error({
        message: err?.data?.error || "You can't scan this QR!",
      });
    }
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensures 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  // Buyer name coming from qr link:

  const parseQRCodeData = (data) => {
    // Convert the query string into an object
    const params = new URLSearchParams(data);
    // Extract the buyerName value
    const name = params.get("buyerName");
    // Decode any encoded characters (like %20 for spaces)
    return decodeURIComponent(name || "");
  };
  const scanQRCodeFromDataURI = async (dataURI) => {
    return new Promise((resolve, reject) => {
      try {
        // Create an image element to load the data URI
        const img = new Image();
        img.onload = () => {
          // Create a canvas to draw the image
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0, img.width, img.height);

          // Extract image data from the canvas
          const imageData = context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );
          const code = jsQR(imageData.data, imageData.width, imageData.height);

          if (code) {
            resolve(code.data); // Resolve the QR code data
          } else {
            reject("No QR code found in the provided image.");
          }
        };

        img.onerror = () => reject("Failed to load the image.");
        img.src = dataURI; // Set the data URI as the source
      } catch (error) {
        reject(
          error.message || "An error occurred while processing the QR code."
        );
      }
    });
  };
  scanQRCodeFromDataURI(bookingData.qrCode)
    .then((result) => {
      const extractedName = parseQRCodeData(result);
      setBuyerName(extractedName);
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  // Qr link extraction ends

  function formatTime(timeStr) {
    // Split the input time into hours, minutes, and seconds
    let [hours, minutes] = timeStr.split(":").map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12 || 12; // Converts 0 to 12 for midnight

    // Return the formatted time
    return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="92.5vh"
      bgcolor="#f5f5f5"
    >
      <Box
        sx={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: 3,
          bgcolor: "white",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h6"
          align="left"
          sx={{ mb: 2 }}
          fontWeight={"bold"}
        >
          Ticket Info
        </Typography>
        <Grid item xs={12} mb={2} align="left">
          <Typography variant="body1">Event Date: {dayjs(eventDate).format("MM/DD/YYYY")}</Typography>
          <Typography variant="h5">{eventName}</Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6} align="left">
            <Typography variant="body2" fontWeight={"bold"}>
              Buyer
            </Typography>
            <Typography variant="body1">{buyerName1}</Typography>
          </Grid>
          <Grid item xs={6} align="right" mb={1}>
            <Typography variant="body2" fontWeight={"bold"}>
              Event Name
            </Typography>
            <Typography variant="body1">{eventName}</Typography>
          </Grid>

          {/* Ticket Details with Booked Quantities */}
          {ticketTypes.length > 0 && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={6} align="left">
                  <Typography variant="body2" fontWeight={"bold"} pl={"1rem"}>
                    Ticket Types
                  </Typography>
                </Grid>
                <Grid item xs={6} align="right">
                  <Typography variant="body2" fontWeight={"bold"}>
                    Booked Tickets
                  </Typography>
                </Grid>
              </Grid>
              {ticketTypes.map((ticket, index) => (
                <Grid container key={index} spacing={2}>
                  <Grid item xs={6} align="left">
                    <Typography variant="body1" pl={"1rem"}>
                      {ticket.type}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} align="right">
                    <Typography variant="body1">
                      {ticket.quantity || 1}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </>
          )}
          <Grid item xs={6} align="left">
            <Typography variant="body2" fontWeight={"bold"}>
              Location
            </Typography>
            <Typography variant="body1">{eventLocation}</Typography>
          </Grid>
          <Grid item xs={6} align="end">
            <Typography variant="body2" fontWeight={"bold"}>
              Time
            </Typography>
            <Typography variant="body1">{dayjs(eventDate).format("hh:mm A")}</Typography>
          </Grid>
          <Grid item xs={6} align="left">
            <Typography variant="body2" fontWeight={"bold"}>
              Total Price
            </Typography>
            <Typography variant="body1">${totalPrice}</Typography>
          </Grid>
          <Grid item xs={6} align="right">
            <Typography variant="body2" fontWeight={"bold"}>
              Ticket Type
            </Typography>
            <Typography variant="body1">
              {bookingData.ticketDetails[0].ticketCategory}
            </Typography>
          </Grid>
        </Grid>
        <Box
          sx={{
            marginTop: "20px",
            marginBottom: "20px",
            width: "100%",
            height: "200px",
            backgroundImage:
              "url(https://t4.ftcdn.net/jpg/02/16/94/65/360_F_216946587_rmug8FCNgpDCPQlstiCJ0CAXJ2sqPRU7.jpg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: "10px",
          }}
        />
        {bookingData?.isOrganizer && <Box sx={{ marginTop: "10px" }}>
          <Button onClick={handleScanComplete} sx={{ border: "1px solid" }}>
            Authenticate
          </Button>
          <Typography
            variant="caption"
            display="block"
            style={{ marginTop: "5px" }}
          >
            Once authenticated, this ticket cannot be scanned again.
          </Typography>
        </Box>}
      </Box>
    </Box>
  );
};

export default AlphaNumericTicketInfo;
